import React from 'react';
import PropTypes from 'prop-types';
import { StatCard } from './designSystem';

/**
 * DEPRECATED — use StatCard from component/common/designSystem.
 *
 * Kept as a thin wrapper so the ~30 pages still importing it render the
 * standard card surface, radius, and type scale today, without each of them
 * being rewritten in one risky pass. Their inline SVG icons still come through
 * (StatCard accepts a node), so what remains per page is swapping those for a
 * STAT_ICONS entry and importing StatCard directly.
 *
 * `downtext` is the old name for StatCard's `note`.
 */
const DashboardInfoCard = ({ icon, title, value, downtext }) => (
  <StatCard icon={icon} title={title} value={value} note={downtext} />
);

DashboardInfoCard.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  value: PropTypes.node,
  downtext: PropTypes.node
};

export default DashboardInfoCard;
